<template>
    <div id="asking-stickers-form-component">
        <v-stepper v-model="form_step" alt-labels elevation="0" height="100px">
            <v-stepper-header>
                <v-stepper-step :step="1" class="px-0" editable>
                    <span :class="form_step === 1 ? 'secondary--text' : 'font-color-light'">
                        {{ $t('asking_stickers_component.stickers') }}
                    </span>
                </v-stepper-step>

                <v-divider class="secondary" />

                <v-stepper-step :editable="form_step >= 2" :step="2" class="px-0">
                    <span :class="form_step === 2 ? 'secondary--text' : 'font-color-light'">
                        {{ $t('asking_stickers_component.coordinates') }}
                    </span>
                </v-stepper-step>

                <v-divider class="secondary" />

                <v-stepper-step :step="3" class="px-0">
                    <span :class="form_step === 3 ? 'secondary--text' : 'font-color-light'">
                        {{ $t('asking_stickers_component.delivery') }}
                    </span>
                </v-stepper-step>
            </v-stepper-header>
        </v-stepper>

        <div class="mb-16 pa-4">
            <div v-if="form_step === 1">
                <ListStickersFormComponent ref="listStickersForm" v-on:goToStepTwo="goToStepTwo" />
            </div>
            <div v-else-if="form_step === 2">
                <CoordinateStickersFormComponent ref="coordinateStickersForm" v-on:goToStepThree="goToStepThree" v-on:resetAskingStickers="resetAskingStickers" />
            </div>
            <div v-else-if="form_step === 3">
                <AddressStickersFormComponent ref="formAddressSticker" v-on:prepareNewOrderSticker="prepareNewOrderSticker" v-on:resetAskingStickers="resetAskingStickers" />
            </div>
        </div>
    </div>
</template>

<script>
import ListStickersFormComponent from '@/components/sticker/form/ListStickersFormComponent.vue'
import CoordinateStickersFormComponent from '@/components/sticker/form/CoordonateStickersFormComponent.vue'
import AddressStickersFormComponent from '@/components/sticker/form/AddressStickersFormComponent.vue'
import OrderStickerRepository from '@/repositories/OrderStickerRepository'

export default {
    name: 'AskingStickersFormComponent',
    components: {
        AddressStickersFormComponent,
        CoordinateStickersFormComponent,
        ListStickersFormComponent
    },
    data() {
        return {
            form_step: 1,

            order_referentiel_stickers: [],

            new_order_sticker: {
                stickers_to_order: [],
                total_vehicle_concerned: 0,
                receiver_reason: '',
                receiver_full_name: '',
                receiver_email: '',
                receiver_phone_number: '',
                address_postal: '',
                address_complement: '',
                code_postal: '',
                city: '',
                country: '',
            },
        }
    },
    methods: {
        resetAskingStickers() {
            this.form_step = 1
        },
        goToStepTwo() {
            this.new_order_sticker.stickers_to_order = this.$refs.listStickersForm.stickers_to_order
            this.new_order_sticker.total_vehicle_concerned = this.$refs.listStickersForm.total_vehicle_concerned
            this.form_step = 2
        },

        goToStepThree() {
            this.new_order_sticker.receiver_reason = this.$refs.coordinateStickersForm.receiver_reason
            this.new_order_sticker.receiver_full_name = this.$refs.coordinateStickersForm.receiver_full_name
            this.new_order_sticker.receiver_email = this.$refs.coordinateStickersForm.receiver_email
            this.new_order_sticker.receiver_phone_number = this.$refs.coordinateStickersForm.receiver_phone_number
            this.form_step = 3
        },

        prepareNewOrderSticker() {
            this.new_order_sticker.address_postal = this.$refs.formAddressSticker.address_postal
            this.new_order_sticker.address_complement = this.$refs.formAddressSticker.address_complement
            this.new_order_sticker.code_postal = this.$refs.formAddressSticker.code_postal
            this.new_order_sticker.city = this.$refs.formAddressSticker.city
            this.new_order_sticker.country = this.$refs.formAddressSticker.country

            this.addNewOrderSticker()
        },

        addNewOrderSticker() {
            OrderStickerRepository.postOrderSticker(this.new_order_sticker)
                .then(() => {
                    this.handleSuccessOrderSticker()
                })
                .catch((error) => {
                    this.manageError(error)

                    if (error.response.status === 409) {
                        this.handleSuccessOrderSticker()
                    }
                })
        },
        handleSuccessOrderSticker() {
            this.showSnackbar('success', this.$t('asking_stickers_component.orders_request_sent'))
            this.resetAskingStickers()
        }
    },
}
</script>

<style>
.v-stepper__label {
    visibility: visible !important;
    display: block !important;
    margin-top: 3px !important;
}

.v-stepper--alt-labels .v-stepper__step {
    flex-basis: 160px !important;
}
</style>
